import { render, staticRenderFns } from "./Shell.vue?vue&type=template&id=767d27a6&scoped=true"
import script from "./Shell.vue?vue&type=script&lang=js"
export * from "./Shell.vue?vue&type=script&lang=js"
import style0 from "./Shell.vue?vue&type=style&index=0&id=767d27a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767d27a6",
  null
  
)

export default component.exports